import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Form, Alert, Button } from 'react-angle-dashboard-components'
import { Paths } from '../../routes/paths'
import { FloatingInputIcon } from '../style'
import { EyeClosedIcon, EyeIcon } from '../icons'
import { FormWrapper } from '../style'
import { AuthContext } from '../../context/Auth/AuthContext'
import { LoginLayout } from './LoginLayout'

export interface LoginFormData {
  email: string
  password: string
  remember: boolean
}

export const Login = () => {
  const history = useHistory()
  const { login } = useContext(AuthContext)
  const [showPassword, setShowPassword] = useState(false)

  const { handleSubmit, formState, register, setError } = useForm({
    mode: 'onChange'
  })

  const onSubmit = handleSubmit(async (data: any) => {
    const { email, password } = data
    try {
      await login(email, password)
      history.push(Paths.home)
    } catch (e: any) {
      setError('email', {
        type: 'manual',
        message: 'Invalid username/password'
      })
    }
  })

  const emailErrorMessage = formState.errors.email?.message

  return (
    <LoginLayout>
      <FormWrapper>
        <Form onSubmit={onSubmit}>
          {emailErrorMessage && (
            <Alert variant="danger">{emailErrorMessage}</Alert>
          )}
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              {...register('email', { required: true })}
              type="email"
              placeholder="Email"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Password</Form.Label>
            <Form.Control
              {...register('password', { required: true })}
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
            />
            <FloatingInputIcon
              role="button"
              onClick={() => setShowPassword((s) => !s)}
            >
              {showPassword ? <EyeClosedIcon /> : <EyeIcon />}
            </FloatingInputIcon>
          </Form.Group>
          <Button type="submit" block disabled={formState.isSubmitting}>
            {!formState.isSubmitting ? 'Sign In' : 'Signing In'}
          </Button>
          <Button
            variant="link"
            block
            onClick={() => history.push(Paths.forgotPassword)}
          >
            Forgot Password?
          </Button>
        </Form>
      </FormWrapper>
    </LoginLayout>
  )
}

export default Login
